var opacity = {
    "light": "0.25",
    "medium": "0.50",
    "dark": "0.75",
};

export { opacity as default };
//# sourceMappingURL=opacity.js.map
